// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_mainHomeContainer__rM6xM {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.Home_homeimageIcon__Satfa {
  width: 25%;
  height: auto;
  margin-right: 4rem;
}

@media screen and (max-width: 991px) {
  .Home_mainHomeContainer__rM6xM {
    flex-direction: column;
  }

  .Home_homeimageIcon__Satfa {
    width: auto;
    height: auto;
    max-height: 40vh;
    margin-right: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".mainHomeContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.homeimageIcon {\n  width: 25%;\n  height: auto;\n  margin-right: 4rem;\n}\n\n@media screen and (max-width: 991px) {\n  .mainHomeContainer {\n    flex-direction: column;\n  }\n\n  .homeimageIcon {\n    width: auto;\n    height: auto;\n    max-height: 40vh;\n    margin-right: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHomeContainer": `Home_mainHomeContainer__rM6xM`,
	"homeimageIcon": `Home_homeimageIcon__Satfa`
};
export default ___CSS_LOADER_EXPORT___;
